<template>
  <!--====== APPIE HERO PART START ======-->

  <section class="appie-hero-area appie-hero-8-area">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="appie-hero-content appie-hero-content-8">
            <h1 class="appie-title">AI로 더 빠른<br>웹·앱 제작</h1>
            <p>스윙투앱 AI Studio — AI + 실무 개발팀 기반 웹·앱 제작 서비스</p>
            <div class="hero-sub-points" style="margin-bottom: 20px;">
              <span style="display:block; margin-bottom: 5px; font-size: 16px; color: #505056;">외주보다 빠르게 · 수정은 더 유연하게 · 결과물은 실서비스 수준으로</span>
            </div>
            <ul>
              <li>
                <a href="javascript:void(0)" @click="goToAIConsult" class="hero-btn-primary" style="font-size: 20px;padding: 10px 20px;">
                  <i class="far fa-magic"></i> <span>AI로 기획 시작하기</span>
                </a>
              </li>
              <li>
                <a href="#" @click.prevent="$root.$emit('open-contact-popup')" class="hero-btn-secondary" style="font-size: 16px;padding: 10px 15px;">
                  <i class="far fa-comments"></i> <span>일반 상담하기</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="appie-hero-thumb-6">
            <div class="thumb text-center wow animated fadeInUp" data-wow-duration="1000ms" data-wow-delay="600ms">
              <img src="@/assets/images/hero-thumb-9.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-8-shape-1">
      <img src="@/assets/images/shape/3.png" alt="">
    </div>
    <div class="home-8-shape-2">
      <img src="@/assets/images/shape/4.png" alt="">
    </div>
    <div class="home-8-shape-3">
      <img src="@/assets/images/shape/1.png" alt="">
    </div>
    <div class="home-8-shape-4">
      <img src="@/assets/images/shape/2.png" alt="">
    </div>
  </section>

  <!--====== APPIE HERO PART ENDS ======-->
</template>

<script>
export default {
  methods: {
    goToAIConsult() {
      if (this.$route.name !== 'AIConsult') {
        this.$router.push({ name: 'AIConsult' });
      }
    }
  }
}
</script>

<style scoped>
.hero-btn-primary {
  background: linear-gradient(135deg, #0a44b9 0%, #6366f1 100%);
  color: #fff !important;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(10, 68, 185, 0.3);
}
.hero-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(10, 68, 185, 0.4);
}
.hero-btn-secondary {
  background: #f5f5f7;
  color: #505056 !important;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s;
}
.hero-btn-secondary:hover {
  background: #e8e8e8;
}
</style>
